import { MainLayout } from "@components/layouts/MainLayout";
import { Settings2 } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Separator } from "@components/ui/separator";
import { PlaceHolder } from "@components/settings/general/PlaceHolder";

export default function Account() {
  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<Settings2 className="h-6 w-6 text-blue-600" />}
            title="General"
            subtitle="Configure your general settings."
          />
        </div>
        <Separator className="mb-12" />
        <div className="space-y-8">
          <div className="pt-4 pb-4">
            <PlaceHolder />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
